<script setup>
import Top from './Top.vue'
import Bottom from './Bottom.vue'
import { useOrderStore } from '@/stores/OrderStore';
import { useAuthStore } from '@/stores/authStore';

const authStore = useAuthStore();
const orderStore = useOrderStore();

</script>

<template>
    <div class="w-6/12 relative flex flex-col justify-between rounded-2xl mt-7 mb-5 bg-white"
      :disabled="orderStore.isThisPaidManualOrder"
      :class="{ 'opacity-50 pointer-events-none': orderStore.isThisPaidManualOrder }"
    >
        <!-- Manual Order Flag/Badge -->
        <div class="w-[95%] mx-auto">
          <div v-show="(authStore.isUserLoggedIn || authStore.isManagerLoggedIn) && orderStore.state.addManualOrder"
            class="absolute top-[-22px] left-[-4] z-10 bg-purple-100 border-2 border-purple-500 text-white text-xs font-semibold px-3 py-1.5 rounded-xl flex items-center gap-1.5 transform  origin-top-left">
            <i class="pi pi-shopping-cart text-purple-500" style="font-size: 12px;"></i>
            <span class="text-purple-500">Manual Order</span>
          </div>
        </div>
        <Top />
        <Bottom />
    </div>
</template>

<style scoped>

</style>
